import { getLabwareDefURI, getTiprackVolume } from '@opentrons/shared-data'

import type { PipetteEntity } from '@opentrons/step-generation'

// NOTE: this is similar to getPipetteWithTipMaxVol, the fns
export const getPipetteCapacity = (
  pipetteEntity: PipetteEntity,
  tipRackDefUri?: string | null
): number => {
  const maxVolume = pipetteEntity.spec.liquids.default.maxVolume
  const tipRackDefs = pipetteEntity.tiprackLabwareDef
  const chosenTipRack =
    tipRackDefs.find(def => getLabwareDefURI(def) === tipRackDefUri) ??
    tipRackDefs[0]
  // TODO: Figure out why we were crashing in getTiprackVolume() because we couldn't
  // find the tiprack def. Maybe tipRackDefUri is null, or tipRackDefs is empty?
  const tipRackTipVol = chosenTipRack ? getTiprackVolume(chosenTipRack) : null

  if (maxVolume != null && tipRackTipVol != null) {
    return Math.min(maxVolume, tipRackTipVol)
  }
  console.assert(
    false,
    `Expected spec for pipette ${pipetteEntity?.id} and tiprack def for ${
      tipRackDefUri
    }. Available tipRackDefs: ${tipRackDefs.map(def => getLabwareDefURI(def))}`
  )
  return NaN
}

export function getMinPipetteVolume(pipetteEntity: PipetteEntity): number {
  const spec = pipetteEntity.spec

  const minVolumes =
    spec != null
      ? Object.values(spec.liquids).map(liquid => liquid.minVolume)
      : []
  let recommendedMinimumDisposalVol: number = 0
  if (minVolumes.length === 1) {
    recommendedMinimumDisposalVol = minVolumes[0]
    //  to accommodate for lowVolume
  } else {
    const lowestVolume = Math.min(...minVolumes)
    recommendedMinimumDisposalVol = lowestVolume
  }

  if (spec != null) {
    return recommendedMinimumDisposalVol
  }

  console.assert(
    false,
    `Expected spec for pipette ${pipetteEntity ? pipetteEntity.id : '???'}`
  )
  return NaN
}
